import React, { useCallback, useState } from 'react';
import '../Header/Header.css';

const Header = () => {

    const [isChanged, setIsChanged] = useState(false);
    const [menuOpen, setMenuOpen] = useState(false);

    const handleToggleChange = useCallback(() => {
        setIsChanged(prevState => !prevState);
        setMenuOpen(!menuOpen);
    }, [menuOpen]);

    return (
        <div className='text-[14px] md:text-xl lg:text-[17px] 2xl:text-xl leading-7 md:leading-8 lg:leading-7 2xl:leading-10'>
            <div className='header grid grid-cols-2 xl:grid-cols-3 items items-center py-2 px-[3%] lg:px-[5%] h-[70px] w-full z-50'>
                <a href='/'>
                    <img src="../assets/os_logo.webp" alt="Logo" className='h-[40px]' />
                </a>

                <div className="hidden xl:flex justify-center">
                <div className="flex items-center gap-3 xl:gap-8 2xl:gap-8">
                    <a href="/WorkPage" className="underline_hover hover:text-[#F56E0F]">Our&nbsp;works</a>
                    <a href="/Photography" className="underline_hover hover:text-[#F56E0F]">Photography</a>
                    <a href="/SocialMedia" className="underline_hover hover:text-[#F56E0F]">Social&nbsp;Media</a>
                    <a href="/3D" className="underline_hover hover:text-[#F56E0F]">3D</a>
                    <a href="/Brand" className="underline_hover hover:text-[#F56E0F]">Brand</a>
                    <a href="/BrochureCreation" className="underline_hover hover:text-[#F56E0F]">Brochure&nbsp;Creation</a>
                    <a href="/FAQ" className="underline_hover hover:text-[#F56E0F]">FAQ</a>
                </div>
                </div>


                <div className='hidden xl:block'>
                    <div className='flex justify-end '>
                        <div className="button_icon_letsCollaborate_btn">
                            <div className="cube_letsCollaborate_btn">
                                <a href="/Collaborate"><span className="side_letsCollaborate_btn front_letsCollaborate_btn hover:text-[#d6d6d6]">Let's collaborate</span></a>
                            </div>
                            <div className="icon_letsCollaborate_btn">
                                <div className="tooltip-container">
                                    <span className="tooltip">Open&nbsp;Studios</span>
                                    <span className="text"></span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className='xl:hidden'>
                    <div className='flex items-center justify-between ml-16'>
                        <div className='mx-2 lg:mx-3'>
                            <div className='h-5 w-5 lg:h-8 lg:w-8 text-[#737373]' />
                        </div>
                        <div className='z-10'>
                            <div className={isChanged ? "change" : ""} onClick={handleToggleChange}>
                                <div className='mx-2 lg:mx-3'>
                                    <div className="bar1"></div>
                                    <div className="bar2"></div>
                                    <div className="bar3"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                    

                    <div className='menu_bg fixed h-screen w-[20em] md:w-[15em] lg:w-[20em]' style={{ right: menuOpen ? 0 : '-100vw', top: 0, transition: 'right 0.5s ease-in-out' }}>
                        <div className='text-lg lg:text-2xl flex flex-col text-right mt-20 mr-[12%]'>
                            <div className='flex justify-end'>
                                <div className="button_icon_letsCollaborate_btn">
                                    <div className="cube_letsCollaborate_btn">
                                       <a href="Collaborate"><span className="side_letsCollaborate_btn front_letsCollaborate_btn hover:text-[#d6d6d6]">Let's collaborate</span></a> 
                                    </div>
                                    <div className="icon_letsCollaborate_btn">
                                        <div className="tooltip-container">
                                            <span className="tooltip">Open&nbsp;Studios</span>
                                            <span className="text"></span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            
                            <div>
                            <div className='flex flex-col ml-auto'>
                                <a href="/WorkPage" className='underline_hover ml-auto hover:text-[#F56E0F]  mt-[8%]'>Our works</a>
                                <a href="/Photography" className='underline_hover ml-auto hover:text-[#F56E0F] mt-[8%]'>Photography</a>
                                <a href="/SocialMedia" className='underline_hover ml-auto hover:text-[#F56E0F] mt-[8%]'>Social Media</a>
                                <a href="/3D" className='underline_hover ml-auto hover:text-[#F56E0F] mt-[8%]'>3D</a>
                                <a href="/Brand" className='underline_hover ml-auto hover:text-[#F56E0F] mt-[8%]'>Brand</a>
                                <a href="/BrochureCreation" className='underline_hover ml-auto hover:text-[#F56E0F] mt-[8%]'>Brochure Creation</a>
                                <a href="/FAQ" className='underline_hover ml-auto hover:text-[#F56E0F] mt-[8%]'>FAQ</a>
                            </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Header;